import React from 'react';
import styled from 'styled-components';
import { isMobile } from 'react-device-detect';

import { Divider, LText, Button, Spacer } from '@lafabrica/core';


const Wrapper = styled.div`
  height: auto;
  position: relative;
  width: 100vw;
  display: flex;
  flex-direction: column;

  @media only screen and (min-width: 769px) {
    flex-direction: row;
  }
`;


const Side = styled.div`
  width: 100vw;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media only screen and (min-width: 769px) {
    width: 50vw;
  }
`;

const LeftSide = styled(Side)`
  height: 200px;

  @media only screen and (min-width: 769px) {
    height: auto;
  }
`;

const RightSide = styled(Side)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 40px;

  @media only screen and (min-width: 769px) {
    min-width: 540px;
    margin-bottom: auto;
  }
`

const Overlay = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: var(--black);
  opacity: 0.4;
  z-index: 0;
`



export const Panel = ({leftSide, rightSide, style, leftStyle, rightStyle, stack=true, overlay=false}) => {

  return (
    <Wrapper style={style}>
      {overlay && <Overlay />}
      <LeftSide style={leftStyle}>
        {leftSide}
      </LeftSide>
      <RightSide style={rightStyle}>
        {rightSide}
      </RightSide>

    </Wrapper>
  );
};
